import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import { MEMBER_LIST_CONTAINER } from './memberListContainer';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  containerType: 'inline-size',
  containerName: MEMBER_LIST_CONTAINER,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * Members of a space, as `MemberListItem` rows separated by hairline dividers.
 * Rows stack on narrow widths and align the role in a column once the list itself is wide enough
 * (container query, not viewport).
 */
export function MemberList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'member-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as MemberListProps };
